import styled from "styled-components";
import { font } from "theme";

export const Headline = styled.h1`
  color: ${(props) => props.color};
  font-family: "Mavis";
  text-transform: uppercase;
  font-weight: ${font.weight.light};
`;
